module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (37).918002ce.jpg";